import { SwapIcon, PoolIcon, FarmIcon } from "../components/Icons";

const menus = [
  {
    name: "Swap",
    name_i18_key: "menu.showdown",
    path: "/swap",
    completed: true,
    icon: <SwapIcon className="w-5 h-5 stroke-slate-100 fill-slate-100" />,
  },
  {
    name: "Pools",
    name_i18_key: "menu.showdown",
    path: "/pools",
    completed: true,
    icon: <PoolIcon className="w-5 h-5 stroke-slate-100 fill-slate-100" />,
  },
  {
    name: "Vest",
    name_i18_key: "menu.showdown",
    path: "/vest",
    completed: true,
    icon: <FarmIcon className="w-5 h-5" />,
  },
  {
    name: "Farms",
    name_i18_key: "menu.showdown",
    path: "/farms",
    completed: true,
    icon: <FarmIcon className="w-5 h-5" />,
  },
  {
    name: "Vote",
    name_i18_key: "menu.showdown",
    path: "/vote",
    completed: true,
    icon: <FarmIcon className="w-5 h-5" />,
  },
  {
    name: "Rewards",
    name_i18_key: "menu.showdown",
    path: "/rewards",
    completed: true,
    icon: <FarmIcon className="w-5 h-5" />,
  },
  // {
  //   name: "Bribes",
  //   name_i18_key: "menu.showdown",
  //   path: "/bribes",
  //   completed: true,
  //   icon: <FarmIcon className="w-5 h-5" />,
  // },
  // {
  //   name: "Swap Stats",
  //   name_i18_key: "menu.showdown",
  //   path: "/swap_stats",
  //   completed: false,
  //   icon: <FarmIcon className="w-5 h-5" />,
  // },
  // {
  //     name: "Charts",
  //     name_i18_key: "menu.showdown",
  //     path: "/charts"
  // },
];

export default menus;
